<template>
  <el-dialog
  :title="title"
  :visible.sync="dialogVisible"
  width="70%"
  :before-close="closeDialog">
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="方案名称" prop="topTitle">
      <el-input v-model="ruleForm.topTitle" style="width: 46%;" placeholder="请输入方案名称"></el-input>
    </el-form-item>

    <el-form-item label="方案简介" prop="topContent">
      <el-input type="textarea" :rows="4" v-model="ruleForm.topContent" style="width: 46%;" placeholder="请输入方案简介"></el-input>
    </el-form-item>

    <el-form-item label="方案详情" prop="solutionText">
      <el-input type="textarea" :rows="8" v-model="ruleForm.solutionText" style="width: 46%;"  placeholder="请输入方案详情"></el-input>
    </el-form-item>

    <el-form-item label="缩略图" prop="subImage">
       <el-upload
        class="avatar-uploader"
        :action="actionUrl"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <img v-if="ruleForm.subImage" :src="baseUrl + ruleForm.subImage" class="avatar">
        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
        <div class="upTipBox" v-else>
          <img class="upIcon" src="../../../assets/images/uploadIcon1@2x.png" />
          <div class="upTip">点击上传 <span class="upTipItem">缩略图</span></div>
        </div>
         <div slot="tip" class="el-upload__tip" style="color: red;">只能上传jpeg,jpg,pmg文件,且不能超过2M，建议长宽为704px*496px</div>
       </el-upload>
    </el-form-item>

    <el-form-item label="应用案例图" prop="solutionAppImage">
       <el-upload
        class="avatar-uploader"
        :action="actionUrl"
        :show-file-list="false"
        :on-success="handleAvatarSuccess2"
        :before-upload="beforeAvatarUpload">
        <img v-if="ruleForm.solutionAppImage" :src="baseUrl + ruleForm.solutionAppImage" class="avatar">
        <div class="upTipBox" v-else>
          <img class="upIcon" src="../../../assets/images/uploadIcon1@2x.png" />
          <div class="upTip">点击上传 <span class="upTipItem">应用案例图</span></div>
        </div>
        <div slot="tip" class="el-upload__tip" style="color: red;">只能上传jpeg,jpg,pmg文件,且不能超过2M，建议长宽为1201px*448px</div>
       </el-upload>
    </el-form-item>

<!--
        :before-remove="beforeRemove" -->
    <el-form-item label="上传附件" prop="fileUrl">
      <el-upload
        class="uploadWrap"
        :action="actionUrl2"
        :before-upload="handlePreview"
        :on-success="handleAvatarSuccess3"
        :on-remove="handleRemove"
        multiple
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList">
        <div class="upTipBox2">
          <img src="../../../assets/images/uploadIcon2@2x.png" class="upIcon" />
          <span>添加附件</span>
        </div>
        <div slot="tip" class="el-upload__tip" style="color: red;">只能上传doc，pdf格式文件</div>
      </el-upload>
    </el-form-item>

  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="submitForm">确 定</el-button>
  </div>
</el-dialog>
</template>
<script>
import {
    serverUrl,
  } from '@/utils/server.js'
import { fetchPlanEdit, fetchPlanAdd } from '@/api/api'
export default {
  data() {
    return {
      mode: 'add',
      dialogVisible: false,
      data: null,
      baseUrl: serverUrl.baseURL, // 'https://platform.iiasx.org.cn/api/',
      ruleForm: {
          topTitle: '',
          topContent: '',
          solutionText: '',
          subImage: '',
          solutionAppImage: '',
          fileUrl: '',
      },
      actionUrl: serverUrl.baseURL + "/api/fileUpload/uploadImage",
      actionUrl2: serverUrl.baseURL + "/api/fileUpload/uploadDoc",
      rules: {
          topTitle: [
            { required: true, message: '请输入方案名称', trigger: 'blur' },
          ],
          topContent: [
            { required: true, message: '请输入方案简介', trigger: 'blur' },
          ],
          solutionText: [
            { required: true, message: '请输入方案详情', trigger: 'blur' },
          ],
          subImage: [
            { required: true, message: '请上传缩略图', trigger: 'blur' },
          ],
          solutionAppImage: [
            { required: true, message: '请上传应用案例图', trigger: 'blur' },
          ],
          fileUrl: [
            { required: true, message: '请上传附件', trigger: 'blur' },
          ]
      },
      // 附件列表
      fileList: [
      ],
      // watch: {
      //   'ruleForm.fileUrl':{
      //     handler(newVal, oldVal) {
      //       console.log('newVal', newVal)
      //       if(newVal) {
      //         this.fileList = [
      //           {
      //             name: '123',
      //             url: newVal
      //           }
      //         ]
      //       }
      //     },
      //     deep: true,
      //     immediate: true
      //   }
      // }
    }
  },
  methods: {
    // 上传附件方法
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.fileUrl = ''
    },
    handlePreview(file) {
      let fileType= file.name.substring(file.name.lastIndexOf('.') + 1)
      const isPdf = fileType === 'pdf'
      const isDoc = fileType === 'doc'
      const isDocx = fileType === 'docx'
      if (!isPdf && !isDoc && !isDocx) {
          this.$message.error('上传附件只能是 doc/pdf 格式!');
          return false
      }
      return true
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.ruleForm.resetFields();
      this.$emit('getList')
    },
    openDialog(data) {
      this.dialogVisible = true
      this.data = data
      this.initData()
      if(data) {
        this.mode='edit'
        this.title='编辑'
      }else {
        this.mode='add'
        this.title='添加'
      }
    },
    initData() {
      const { topTitle, topContent, solutionText, subImage, solutionAppImage, fileUrl} = this.data
      this.ruleForm.topTitle = topTitle
      this.ruleForm.topContent = topContent
      this.ruleForm.solutionText = solutionText
      this.ruleForm.subImage = subImage
      this.ruleForm.solutionAppImage = solutionAppImage
      this.ruleForm.fileUrl = fileUrl
      if(this.ruleForm.fileUrl) {
        let fileName = this.ruleForm.fileUrl.substring(this.ruleForm.fileUrl.lastIndexOf('/') + 1)
        this.fileList = [{
          name: fileName,
          url: this.ruleForm.fileUrl,
        }]
      }

    },
    submitForm() {
      let v = this
      this.$refs.ruleForm.validate((valid) => {
        if(valid) {
          let params = {
            // id: this.data.id,
            ...v.ruleForm
          }
          if(this.mode == 'edit') {
            params.id = v.data.id
            fetchPlanEdit(params).then(res => {
              if(res.code == 1) {
                this.$message.success('编辑成功');
                this.closeDialog()
              }else {
                this.$message.error('编辑失败');
              }
            })
          }else if(this.mode == 'add') {
            fetchPlanAdd(params).then(res => {
              if(res.code == 1) {
                this.$message.success('添加成功');
                this.closeDialog()
              }else {
                this.$message.error('添加失败');
              }
            })
          }

        }
      })
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.subImage = res
    },
    handleAvatarSuccess2(res, file){
        this.ruleForm.solutionAppImage = res
    },
    handleAvatarSuccess3(res, file){
        this.ruleForm.fileUrl = res
    },
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },




  }
}
</script>
<style scoped>
.avatar-uploader >>> .el-upload {
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }




  .upTipBox{
    text-align: center;
    width: 560px;
    height: 188px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .upTipBox .upIcon{
    width: 73px;
  }
  .upTipBox .upTip{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #2050D1;
  }
  .upTipBox .upTipItem {
    color: rgba(128, 128, 128, 1);
  }

  .avatar {
    width: 560px;
    height: 188px;
    display: block;
  }

  .upTipBox2 .upIcon{
    width: 20px;
    vertical-align: middle;
  }
  .upTipBox2 span {
     font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #2050D1;
    vertical-align: middle;
  }

  .uploadWrap{
    border: 1px solid rgba(16, 36, 90, 0.10);
    border-radius: 8px;
    padding: 15px 30px;
    width: 500px;
  }

</style>



// WEBPACK FOOTER //
// src/views/console/components/SolveDialog.vue